export default {"src":"/_next/static/media/arnx.34075695.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};